<template>
<div class="pa-40">
  <h2 class="dark-orange--text font30 p-flex">Resumen del proceso de gestión de hallazgo {{selectedItem.finding_code || '(Código Por Definir)'}}</h2>
  <v-stepper v-model="current_step" alt-labels class="stpAC boxShadowNone">
    <v-stepper-header>
      <template v-for="(st,i) in steps">
        <v-stepper-step :complete="(i+1)<current_step" :step="`${i+1}`" :key="i" @click="change_step(()=>ext_chn_stp=(i+1))">
          {{action_steps_info_by_step[(i+1)].name}}
        </v-stepper-step>
        <v-divider v-if="i<(steps.length-1)" :key="`D${i}`"/>
      </template>
    </v-stepper-header>
  </v-stepper>
  <component :is='false?"div":"exp-panel"' :label="get_action_label('finding_data')" label_class="exp_panel_title" :expanded="true">
    <div class='form-v2'>
      <h3 class="sub_t p-flex">Antecedentes generales</h3>
      <v-layout>
        <in-rq-ac :value.sync="selectedItem.critical_asset" :obj_val.sync="selected_ca" :md="12" :i_search_ex_filter="in_rq_ac_i_search_ex_filter"/>
      </v-layout>
      <v-layout>
        <v-flex>
          <v-checkbox style="margin-top:0" v-model="in_rq_ac_i_search_ex_filter_check" label="Incluir BCEI's que se encuentran en el listado de histórico desactivado"/>
        </v-flex>
      </v-layout>
      <v-layout wrap> 
        <value_container label="Organización" :value="organization_name" md="4"/>
        <value_container md="4" label="Áreas Impactadas" :value="impacted_areas_names"/>
      
        <value_container md="4" label="TAG Equipo" :value="selected_ca.tag"/>
        <value_container md="4" label="Functional Location" :value="selected_ca.functional_location"/>
        <value_container md="4" label="Riesgo Material" :value="selected_ca.bowtie_name"/>

        <value_container md="4" label="Estándar" :value="standard_name || selectedItem.critical_asset_standards_name"/>
        <in-calendar :date.sync="selectedItem.creation_date" label="Fecha de creación" md="4" :view_only="!save_only"/>
        <in-calendar :date.sync="selectedItem.inspection_date" label="Fecha de inspección" md="4" :required="true"/>

        <in-num v-model="selectedItem.sap_notice_inspection_number" label="N° Aviso de Inspección 1SAP" md="4"/>
        <in-num v-model="selectedItem.sap_ot_inspection_number" label="N° OT de Inspeccion 1SAP" md="4"/>
        <in-select :value.sync="selectedItem.technical_report" label="Hallazgo Identificado mediante" md="4" :items="technical_reports"/>

        <in-text v-model="selectedItem.inspection_place" label="Sector Inspeccionado" md="4"/>
        <in-text v-model="selectedItem.notebook_code" label="Código PED" md="4"/>
        <in_speciality :value.sync="selectedItem.speciality" md="4"/>

        <in-select v-if="selected_ca.organization == 4"
          :value.sync="selectedItem.npi_cho_specification"
          :view_only="!!selectedItem.finding_code"
          :label="`Área NPI&CHO`" md="4" :items="['NPI','CHO']"/>
      </v-layout>

      <v-layout>
        <in_select2 :value.sync="selectedItem.remediation_status" label="Estatus de Remediación" md="4" :items="remediation_status"/>
      </v-layout>

      <in-text-area v-model="selectedItem.description" label="Descripción del hallazgo identificado" class="flex"/>

      <v-layout>
        <v-flex>
          <fs1 tag="h2">Ubicación Geográfica (Lat: -24.272949, Lng: -69.070001)</fs1>
          <fs1 tag="div" style="color: gray;">Use Cmd + Click (macOS) o Ctrl + Click (Windows/Linux) para fijar el punto, o ingrese las coordenadas manualmente.</fs1>
        </v-flex>
      </v-layout>

      <v-layout style="align-items: center;">
        <in-num v-model="selectedItem.lat" label="Latitud" md="4" :float="true" :min="null" :step="1/1000"/>
        <in-num v-model="selectedItem.lng" label="Longitud" md="4" :float="true" :min="null" :step="1/1000"/>
        <v-flex md4 style="text-align: right;">
          <v-btn color="primary" outlined @click="Object.assign(map_pos_cen,map_marker_pos)">
            <v-icon>location_on</v-icon>
            <span>Centrar</span>
          </v-btn>
          <v-btn color="primary" outlined @click="restore_map_pos">
            <v-icon>cached</v-icon>
            <span>Restaurar</span>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex>
          <GmapMap
            :center="map_pos_cen"
            @click="on_map_click"
            @center_changed="(a)=>{map_pos_cen_e.lat=a.lat();map_pos_cen_e.lng=a.lng()}"
            @dragend="(a)=>Object.assign(map_pos_cen,map_pos_cen_e)"
            :zoom="12"
            map-type-id="hybrid"
            style=" height: 450px"
            :options="{mapId:'3901562e286aae9f35e1081f'}">
            <GmapMarker
            @dragend="(a)=>{selectedItem.lat=a.latLng.lat();selectedItem.lng=a.latLng.lng()}"
              :position="map_marker_pos"
              :clickable="true"
              :draggable="true"/>
          </GmapMap>
        </v-flex>
      </v-layout>

      <h3 class="sub_t p-flex">Tipo de Impacto y Calculo de Prioridad</h3>
      <v-layout>
        <in_select2 :value.sync="selectedItem.impact_type" label="Tipo de Impacto" md="4" :items="impact_types"/>
      </v-layout>

      <v-layout v-if="selectedItem.impact_type === 'financial'">
        <value_container md="4" label="Áreas Impactadas" :value="impacted_areas_names"/>
        <in-range v-model="selectedItem.impact_percentage" md="4" label="Porcentaje de Impacto %" />
        <!-- <value_container md="4" label="Porcentaje de Impacto" :value="impact_percentage"/> -->
        <value_container md="4" label="EBITDA Hallazgo" :value="ebit"/>
      </v-layout>

      <v-layout v-if="selectedItem.impact_type === 'financial'">
        <in-num v-model="selectedItem.mfl_days" label="Días de detención" :float="true" md="4"/>
        <value_container md="4" label="Pérdida Financiera en MUSD del hallazgo identificado" :value="selectedItem.computed_financial_mfl"/>
        <v-flex md4 style="padding: 0 !important;">
          <MflsValues_rev :asset="selectedItem" :set="()=>dialogMfl=true" :mfls="['mfl_financial']"/>
        </v-flex>
      </v-layout>

      <v-layout v-if="mfl_can_edit">
        <v-flex md4 style="padding: 0 !important;">
          <MflsValues_rev :asset="selectedItem" :set="()=>dialogMfl=true" :mfls="[selected_mfl_key]"/>
        </v-flex>
      </v-layout>
        
      <v-layout>
        <Likelihood :value.sync="selectedItem.likelihood"/>
        <v-flex md4>
          <b>Priority</b>
          <div class="p_box" :class="[p_color,dark_t?'dark':'']" @click="()=>priority_dialog=true">{{selectedItem.priority}}</div>
        </v-flex>
      </v-layout>
      <br>
      <template v-if="!simulation">
        <div class="p-flex" v-if="selectedItem.finding_code">
          <h3 class="sub_t">Listado de inspecciones anteriores</h3>
          <table_reinspec
            :f_id="selectedItem.id"
            :items="selectedItem.inspection_dates"
            :global_risk_standard_version="selectedItem.global_risk_standard_version">
            <template v-slot:edit_list_item="{item}">
              <v-list-item @click="select_edit_reinspec(item)" v-if="myPermissions.includes(25)">
                <v-icon>edit</v-icon>
                <span>Editar ficha de inspección</span>
              </v-list-item>
            </template>
          </table_reinspec>
          <div class="textAlignCenter">
            <v-btn color="primary" @click="select_add_reinspec()"><v-icon>add</v-icon>Agregar</v-btn>
          </div>
        </div>
        <div class="p-flex">
          <h3 class="sub_t">
            Comentarios
            <fs1-tooltip text="En este campo de texto puede ingresar los antecedentes técnicos, referencias, objetivos, metodología, desarrollo, recomendaciones u otra información escrita adicional sobre el hallazgo en cuestión"/>
          </h3>
          <in-text-area v-model="selectedItem.comment"/>          
        </div>
        <div class="p-flex">
          <TableFiles :rows="selectedItem.documents" :merge_item="{action: selectedItem.id}">
            <h3 class="sub_t">Documentos</h3>
          </TableFiles>
        </div>
        <div class="p-flex">
          <h3 class="sub_t">Registro fotográfico</h3>
          <imgs-container :selectedItem="selectedItem.photographic_record" :merge_item="{action: selectedItem.id}" delete_name="action_photographic_record" post_name="action_photographic_records"/>
        </div>
        <br>
        <!-- <in-table-user :items="selectedItem.participants" title="Participantes de la identificación de este hallazgo" name="participante"/> -->
        <!-- <in-table-user  :items="selectedItem.responsible" title="Responsable de la remediación" name="responsable" :max="1"/> -->
      </template>
    </div>
  </component>
  <div class="mt-20" style="padding-bottom:40px">
    <div class="float-r">
      <v-btn color="secondary" @click="gotToList">
        <v-icon></v-icon>
        <span>Cerrar</span>
      </v-btn>
      <v-btn color="primary" @click="normal_save" :disabled="saving || (save_only && !selectedItem.id)">
        <span>{{save_only?'Guardar':'Enviar'}}</span>
      </v-btn>
    </div>
  </div>
    
  <v-dialog v-model="dialog" persistent max-width="400">
    <v-card class="pa-20 textAlignCenter">
      <h1 class="dark-orange--text">{{save_only?'Guardado':'Finalizado'}}</h1>
      <br>
      <p>
        <v-icon>check</v-icon>
        <fs1-span>Hallazgo ha sido {{save_only?'guardado':'incorporado en plataforma'}} con el código:</fs1-span>
      </p>
      <p class="officialized_finding_code_hint">Haga clic en el código para copiarlo al portapapeles.</p>
      <p
        class="officialized_finding_code"
        :class="{ 'officialized_finding_code--copied': findingCodeCopied }"
        @click="copy_finding_code">
        {{ selectedItem.finding_code }}
        <v-icon small class="officialized_finding_code_icon">content_copy</v-icon>
      </p>
      <p v-if="findingCodeCopied" class="officialized_finding_code_copied">
        <v-icon small color="success">check</v-icon>
        Código copiado al portapapeles.
      </p>
      <br>
      <v-btn color="secondary" @click="gotToList">
        <span>cerrar</span>
      </v-btn>
    </v-card>
  </v-dialog>
  <mfl_modal :item="selectedItem" :selectedMfl="selected_mfl_key" :dialog.sync="dialogMfl" :edit="mfl_can_edit"/>
  <priority_modal :item="selectedItem" :dialog.sync="priority_dialog" :edit="false" :x="p_x" :y="p_y"/>

  <fs1-dialog id="unfilled_action" template="unfilled" max_width="400">
    <template v-slot:body>
      <ul class="textAlignLeft">
        <li v-for="(k,i) in unfilled" :key="i">{{unfilled_labels[k]}}</li>
      </ul>
    </template>
    <template v-slot:footer="{close}">
      <v-btn color="primary" @click="close">Aceptar</v-btn>
    </template>
  </fs1-dialog>
  <fs1-dialog id="reinspec_action" template="warning" max_width="800">
    <template v-slot:body>
      A continuación será redireccionado al formulario para {{re_inspec?'modificar':'agregar'}} inspecciones. Si desea continuar guardando su progreso, presione el botón "Guardar y Continuar". Si desea continuar pero descartar su progreso, presionar "Continuar sin guardar". Si desea continuar editando el hallazgo, presione "Cancelar"
    </template>
    <template v-slot:footer="{close}">
      <v-btn color="primary" @click="{close();reinspec_save()}"><v-icon>save</v-icon>Guardar y Continuar</v-btn>
      <v-btn color="primary" @click="()=>{close();gotToReInspect()}"><v-icon>delete</v-icon>Continuar sin guardar</v-btn>
      <v-btn color="secondary" @click="close">Cancelar</v-btn>
    </template>
  </fs1-dialog>
  <edit_steps v-if="save_only" :finding_code="s_finding_code" :id="s_id" :steps="steps" :aaa="true" :ext_chn_stp="ext_chn_stp"/>
</div>
</template>

<script>
import action_mfl from '@/modules/CA_SP/mixins/action_mfl.js'
import MflTableOld from '@/components/modals/MflTableOld.vue';
import value_container from '@/components/outputs/value_container.vue';
import TableFiles from '@/components/actions/table/files.vue';
import SXP from '@/components/actions/SXP.vue';
import in_functional_location  from '@/components/inputs/functional_location.vue';
import in_speciality from '@/components/inputs/speciality.vue';
import in_select2 from '@/components/inputs/in-select2.vue';
import in_img from '@/components/inputs/in-img.vue';
import { remediation_status,technical_reports } from '@/objects/general.js';
import { recursiveCopy } from '@/functions/general.js';
import action_steps_info from '@/modules/CA_SP/mixins/action_steps_info.js';
import edit_steps from '@/modules/CA_SP/mixins/edit_steps.js';
import table_reinspec from '@/modules/CA_SP/components/actions/table_reinspec.vue';
const def_map_pos = {lat: -24.264548948399803, lng: -69.07323471840661};
export default {
  props:['selectedItem','save_only','done','edi_si','und_si','check_dif'],
  mixins:[edit_steps,action_steps_info,action_mfl],
  components:{
    table_reinspec,
    in_speciality,
    value_container,
    in_img,
    TableFiles,
    SXP,
    MflTableOld,
    in_select2,
    in_functional_location,
  },
  data() {
    return {
      map_pos_cen:{...def_map_pos},
      map_pos_cen_def:{...def_map_pos},
      map_pos_cen_e:{...def_map_pos},
      in_rq_ac_i_search_ex_filter:{
        ae__state:'2',
        discharge_date__isnull:true,
      },
      in_rq_ac_i_search_ex_filter_check:false,
      re_inspec:null,
      remediation_status,
      steps:[
        {key:'new'},
        {key:'remediation'},
        {key:'following_remediation_action'},
        {key:'closing_remediation_action'},
        /* {key:'closing_action'}, */
      ],
      current_step:1,
      saving:false,
      unfilled:[],
      unfilled_labels:{
        responsible: 'Responsable',
        critical_asset: 'BCEI',
        inspection_place:'Sector Inspeccionado',
        inspection_date:'Fecha de inspección',
        standard:'Estándar',
        speciality:'Especialidad',
        process:'Hallazgo identificado mediante',
        technical_report:'Hallazgo Identificado mediante',
        description:'Descripción del hallazgo identificado',
        impact_type:'Tipo de Impacto',
        likelihood:'Tiempo Estimado para Falla',
        npi_cho_specification:'Área NPI&CHO',
      },
      technical_reports,
      dialog:false,
      findingCodeCopied:false,
      /* usar prop required de inputs usando el scheme .not_null */
      scheme:{
        id: {type:'int'},
        status: {type:'int'},
        critical_asset: {type:'int'},
        description: {type:'string'},
        notification_type: {type:'string'},
        sap_number: {type:'string'},
        inspection_place: {type:'string'},
        inspection_date: {type:'date'},
        finding_creation_date: {type:'date'},
        creation_date: {type:'date'},
        report_date: {type:'date'},
        speciality: {type:'int'},
        severity: {type:'int'},
        likelihood: {type:'int'},
        rrr: {type:'int'},
        priority: {type:'string'},
        technical_background: {type:'string'},
        inspection_goal: {type:'string'},
        inspection_methodology: {type:'string'},
        inspection_development: {type:'string'},
        recomendation: {type:'string'},
        participants:{type:'array'},
computed_financial_mfl: {type:'int'},
        mfl_days: {type:'int'},
        mfl_financial: {type:'int'},
        /*  */
        comment: {type:'string'},
        impact_type: {type:'string'},
        mfl_health_and_safety: {type:'int'},
        mfl_environment: {type:'int'},
        mfl_community: {type:'int'},
        mfl_legal: {type:'int'},
        mfl_reputation: {type:'int'},
        mfl_sustainability: {type:'int'},
        technical_report:{type:'string'},
        process:{type:'string'},
        responsible:{type:'array'},
        standard: {type:'int'},
        parent_finding_code: {type:'string'},
        notebook_code:{type:'string'},
        npi_cho_specification:{type:'string'},
        ebit: {type:'int'},
        impact_percentage: {type:'int'},
        notify_ot_inspection_number: {type:'int'},
        sap_notice_inspection_number: {type:'int'},
        sap_ot_inspection_number: {type:'int'},
        remediation_status: {type:'int'},
        inspection_dates:{type:'array'},
        lat: {type:'float'},
        lng: {type:'float'},
      },
    };
  },
  computed:{
    standard_name(){return this.standardName(this.selected_ca.standard)},
    organizations() {return this.$store.getters.organizations},
    standards() {return this.$store.getters.standards},
    organization_name(){ return (this.organizations.find(o=>o.id===this.selected_ca.organization)||{}).name},
    simulation(){ return this.selectedItem.status === 4 },
    s_finding_code(){ return ((i)=>i?i.finding_code:null)(this.selectedItem) },
    s_id(){ return ((i)=>i?i.id:null)(this.selectedItem) },
    fixed_selectedItem_rrr(){ return this.fixed(this.selectedItem.rrr)||''},
    selectedItem_computed_financial_mfl_fixed(){return this.fixed(this.selectedItem.computed_financial_mfl)},
    route_params_id(){return this.$route.params.id},
    c_ebit_date(){
      return this.selectedItem.inspection_dates.length > 0
        ? this.selectedItem.inspection_date
        : this.selectedItem.creation_date;
    },
    map_marker_pos() {
      return {
        lat: this.selectedItem.lat ?? def_map_pos.lat,
        lng: this.selectedItem.lng ?? def_map_pos.lng,
      };
    },
  },
  created() {
    this.sync_map_center();
  },
  watch:{
    'selectedItem.id'(id, oldId) {
      if (id && id !== oldId) this.sync_map_center();
    },
    'c_ebit_date'(v){ this.ebit_date = v},
    in_rq_ac_i_search_ex_filter_check(v){ 
      if(v) {
        this.in_rq_ac_i_search_ex_filter.ae__state='';
        this.in_rq_ac_i_search_ex_filter.discharge_date__isnull='';
      }else{
        this.in_rq_ac_i_search_ex_filter.ae__state='2';
        this.in_rq_ac_i_search_ex_filter.discharge_date__isnull=true;
      }
    },
  },
  methods:{
    standardName(id) {
      if(!id) return '';
      const sts = this.standards.filter(f => id.includes(f.id));
      return sts && sts.length? sts.map(m => m.name).join(', '): '';
    },
    change_step(f_st){
      if (this.check_dif) this.check_dif(f_st);
      else f_st();
    },
    sync_map_center() {
      Object.assign(this.map_pos_cen, this.map_marker_pos);
    },
    restore_map_pos() {
      this.selectedItem.lat = def_map_pos.lat;
      this.selectedItem.lng = def_map_pos.lng;
    },
    on_map_click(e) {
      const dom = e.domEvent;
      if (!dom || (!dom.ctrlKey && !dom.metaKey)) return;
      this.selectedItem.lat = e.latLng.lat();
      this.selectedItem.lng = e.latLng.lng();
    },
    check() {
      const toCheck = this.selectedItem;
      const list = [];
      [ 
        /* 'responsible', */
      ].forEach(c => !toCheck[c].length && list.push(c));

      [ 
        'critical_asset',
        'inspection_place',
        'inspection_place',
        /* 'standard', */
        'speciality',
        /* 'process', */
        'technical_report',
        'description',
        'impact_type',
        'likelihood',
      ].forEach(c => toCheck[c] === null && list.push(c));
      //si es npi&cho
      if (this.selected_ca.organization == 4 && !toCheck.npi_cho_specification) list.push('npi_cho_specification');
      return list;
    },
    gotToList() {
      if(this.done !== undefined) this.$emit('update:done', true);
      this.$router.push({ name: 'findings'})
    },
    gotToReInspect() {
      const re_inspec = this.re_inspec?this.re_inspec.id:null;
      this.re_inspec = null;
      this.$router.push({ 
        name: 'findings/re_inspec', 
        params: { k: 1, id:this.s_id, re_inspec },
        path: '/findings/re_inspec', 
        query: {key: 'not-sensitive'} 
      });
    },
    select_add_reinspec(){
      this.re_inspec = null;
      this.open_dialog('reinspec_action')
    },
    select_edit_reinspec(item){
      this.re_inspec = item;
      this.open_dialog('reinspec_action')
    },
    normal_save(){
      this.save(()=>{
        if (this.route_params_id && this.selectedItem.status != 4) this.select_edit_step(this.selectedItem)
        else {
          this.findingCodeCopied = false;
          this.dialog = true;
        }
      })
    },
    async copy_finding_code(){
      const text = this.selectedItem.finding_code;
      if (!text) return;
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(text);
        } else {
          const el = document.createElement('textarea');
          el.value = text;
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
        }
        this.findingCodeCopied = true;
        this.setSnackbar({message: 'Código copiado al portapapeles.', class: 'success'});
      } catch (e) {
        this.setSnackbar({message: 'No se pudo copiar el código.', class: 'error'});
      }
    },
    reinspec_save(){ this.save(()=>this.gotToReInspect()) },
    async save(CB){
      if (this.saving) return;
      if (!this.save_only) {
        this.unfilled = this.check();
        if (this.unfilled.length > 0) return this.open_dialog('unfilled_action');
      }
      this.saving = true;
      if (!this.selectedItem.ignore_ebit_calculation) this.selectedItem.ebit = this.ebit;
      const to_save = {};
      Object.keys(this.scheme).forEach(k=>to_save[k]=this.selectedItem[k]);
      this.dev_log({to_save});
      to_save.status = this.save_only?0:1;
      if (this.save_only) delete to_save.status;
      this.requests.patch['reported_action'](to_save)
        .then(r => {
          this.selectedItem.finding_code = r.finding_code;
          if(this.edi_si) {
            this.$emit('update:edi_si', this.selectedItem);
            this.$emit('update:und_si', recursiveCopy(this.selectedItem));
          }
          this.saving = false;
          if (CB) CB();
        })
        .catch(e => {
          this.saving = false;
          this.getError(e);
        });
    },
  }
};
</script>

<style scoped>
.officialized_finding_code_hint{
  font-size: 0.9rem;
  color: #666;
  margin-top: 8px;
}
.officialized_finding_code{
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 1.4rem;
  font-weight: bold;
  margin-top: 8px;
  padding: 8px 12px;
  border-radius: 4px;
  cursor: pointer;
  user-select: none;
  transition: background-color 0.2s ease;
}
.officialized_finding_code:hover{
  background-color: #eef5ff;
}
.officialized_finding_code--copied{
  background-color: #e8f5e9;
}
.officialized_finding_code_icon{
  opacity: 0.7;
}
.officialized_finding_code_copied{
  margin-top: 8px;
  color: #2e7d32;
  font-weight: bold;
}
</style>
